<template>
	<div class="popup-reset" v-hammer:tap="close">
		<div class="bg"></div>
		<div class="content">
			<div class="title">{{ 'reset_progression' | lang }}</div>

			<p>{{ 'reset_progression_sentence_1' | lang }}</p> 
			<p class="red">{{ 'reset_progression_sentence_2' | lang }}</p>

			<br>

			<ui-button v-hammer:tap="reset_progression">{{ 'delete_progression' | lang }}</ui-button>
			
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiButton from '@/components/ui/ui-button'

export default {
	name: 'popup-reset',
	props: {
		popup: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
	},
	methods: {
		reset_progression() {
			this.$store.dispatch('reset_user_progression')
		},
		close(e) {
			if (!e.srcEvent.stopped) this.$emit('close')
		}
	},
	components: { UiButton }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-reset
	absolute 0
	color #fff
	flex center center
	text-align center
	.bg
		absolute 0
	.content
		width calc(100% - 64px)
		max-width 600px
		margin 0 auto
		flex center center column
		transform translateY(-24px)
		// background-color red
		.title
			margin 0 0 80px 0
			font-size 8rem
			line-height 0.7em
		p
			margin 0 0 16px 0
			font-size 3.2rem
			&.red
				color red
		

</style>
